import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PageHeadingService } from '../../services/page-heading.service';
import { ProfileService } from '../../profile/profile.service';
import { LoggingService } from '../../services/logging.service';
import { FileService } from '../file.service';
@Component({
  selector: 'app-new-file',
  templateUrl: './new-file.component.html',
  styleUrls: ['./new-file.component.css'],
  providers: [LoggingService]
})
export class NewFileComponent implements OnInit {
  contents ={};
  selectedFolder = null;
  constructor(private logServ: LoggingService,
    private fileService: FileService,
    private curRoute: ActivatedRoute,
    private profileService: ProfileService,
    private pageHeadingService: PageHeadingService) { }

  selectedFile: File = null;
  fileInputTitle = null;
  fileInputDescription = null;
  fileToUpload = null;
  btnIsDisabled = false;
  dispSuccess = false;
  ngOnInit() {
    //console.log(this.curRoute.snapshot);
    this.selectedFolder=this.curRoute.snapshot.params['folder'];
    this.pageHeadingService.setPageHeading("Upload to - "+this.selectedFolder);
  }

  onFileLoad(event){
    this.selectedFile = <File>event.target.files[0];

  // Add your values in here

  }

  uploadFile(){
    this.btnIsDisabled = true;
    // this.httpServ.getHttpConfig()
    //   .subscribe(results => {
    //     this.contents = results[0];
    //     //console.log(this.contents);
    //   });

    const fd = new FormData();
    const target: string = 'file';
    fd.append('fileToUpload',this.selectedFile,this.selectedFile.name);
    fd.append('fileInputTitle',this.fileInputTitle);
    fd.append('fileInputDescription',this.fileInputDescription);
    fd.append('fileInputFolder',this.selectedFolder);

    this.fileService.postNewProjectFile(fd,target)
      .subscribe((res) => {
        //console.log(res);
          this.dispSuccess = true;
          this.selectedFile = null;
          this.fileToUpload = null;
          this.fileInputTitle = null;
          this.fileInputDescription = null;
          this.btnIsDisabled = false;
      });

    //console.log(this.httpServ.results);
    //this.logServ.logBtnClick(this.contents);
  }


}
